module.exports = __webpack_public_path__ + "static/media/Post1.890799a0.png";